const ResolutionCentre = () => {
  return (
    <>
      <p> Resolution Centre</p>
    </>
  );
};

export default ResolutionCentre;
